<template>
  <LazyModalsModalMobileBottomSheet
      v-if="currW <= 470 && opened"
      :modal-id="ModalIds.COMPARISON_MARKETS_STATS"
  >
    <slot></slot>
    <template #footer>
      <slot name="footer"></slot>
    </template>
  </LazyModalsModalMobileBottomSheet>
  <slot v-else-if="currW > 470"></slot>
</template>

<script lang="ts" setup>
import {ModalIds} from "~/types/Modals";

const props = defineProps<{
  opened: boolean
}>()
const currW = useResize()
</script>

<style scoped>

</style>